import { Component, DestroyRef, Inject, inject, OnDestroy } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { DashboardResolve } from '../../shared/models/routeTyping';
import { TypedRoute } from '../../shared/utils/router.utils';
import { ParkingSession } from '../../shared/models/parkingSession';
import { ActivatedRoute } from '@angular/router';
import { AlertService, runtimeAlerts } from '../../shared/services/alert.service';
import { GarageContract } from '../../shared/models/contract';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.scss',
})
export class DashboardComponent implements OnDestroy {
  private destroyRef = inject(DestroyRef);
  openParkingSessions: ParkingSession[] = [];
  hasContracts = false;

  constructor(
    @Inject(ActivatedRoute) private route: TypedRoute<DashboardResolve>,
    private alertService: AlertService,
  ) {
    this.route.data.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data) => {
      this.openParkingSessions = data.dashboardApiResponse.open_parking_sessions;
      this.hasContracts = data.dashboardApiResponse.garage_contracts.length > 0;
      if (this.hasContractsWithNoLicensePlate(data.dashboardApiResponse.garage_contracts)) {
        this.alertService.add(runtimeAlerts['contractWithoutLicensePlateAlert']);
      }
    });
  }

  hasContractsWithNoLicensePlate(garageContracts: GarageContract[]): boolean {
    return garageContracts.some(
      (contract) => contract.license_plates.length === 0 && (!contract.end || new Date(contract.end) > new Date()),
    );
  }

  ngOnDestroy() {
    this.alertService.removeAlert(runtimeAlerts['contractWithoutLicensePlateAlert']);
  }
}
